import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export interface CrumbProps {
  path: string;
  text: string;
  current?: boolean;
}

export interface CrumbTemplateProps extends Omit<CrumbProps, 'path' | 'text'> {}

export default function Crumb({ path, text, current = false }: CrumbProps) {
  const navigate = useNavigate();

  return (
    <Link
      to={path}
      key={path}
      onClick={() => navigate(path)}
      className={`${current ? 'font-medium text-title' : 'text-body'} hover:underline`}
    >
      {text}
    </Link>
  );
}
